import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { AuthService } from '../data-services/auth.service';


export class SecurityClaim {
  Claim: string = "";
  HasAccess: boolean = false;
  LabId: number = 0;
}

export class SecurityUser {
  IsAuthenticated: boolean = false;
  UserName: string = "";
  FirstName: string = "";
  LastName: string = "";
  EulaMustBeAccepted: boolean = false;
  Claims: SecurityClaim[] = [];
}

@Injectable({ providedIn: 'root' })
export class SecurityService {
  public currentUser: SecurityUser = new SecurityUser();
  private updateUser;
  user: Observable<SecurityUser> = Observable.create((observer) => {
    this.updateUser = function (newValue) {
      observer.next(newValue);
      observer.complete();
    }
  });
  constructor(public authService: AuthService) { }

  getCurrentUser(): Observable<SecurityUser> {
    return of<SecurityUser>(this.currentUser);
  }

  loadCurrentUser(): any {
    this.resetSecurityObject();

    var promise = new Promise((resolve, reject) => {
      this.authService.get().toPromise().then((data: any) => {
        this.currentUser = data;
        this.currentUser.IsAuthenticated = true;
        resolve(this.currentUser);
      });
    });
    return promise;
  }

  setUser(user) {
    this.resetSecurityObject();
    this.currentUser = user;
    this.currentUser.IsAuthenticated = true;
    this.updateUser(user);
  }


  logout(): void {
    this.logOutCurrentUser().then((data: any) => {
      this.resetSecurityObject();
    });
  }

  logOutCurrentUser(): any {
    this.resetSecurityObject();
    var promise = new Promise((resolve, reject) => {
      this.authService.logout().toPromise().then((data: any) => {

      });
    });
    return promise;
  }

  resetSecurityObject(): void {
    this.currentUser.IsAuthenticated = false;
    this.currentUser.UserName = "";
    this.currentUser.FirstName = "";
    this.currentUser.LastName = "";
    this.currentUser.Claims = [];
  }
  // This method can be called a couple of different ways
  // *hasClaim="'claimType'"  // Assumes claimValue is true
  // *hasClaim="'claimType:value'" // Compares claimValue to value
  // *hasClaim="['claimType1','claimType2:value','claimType3']"
  hasClaim(claimType: any): boolean {
    let ret: boolean = false;

    // See if an array of values was passed in.
    if (typeof claimType === "string") {
      ret = this.isClaimValid(claimType);
    }
    else {
      let claims: string[] = claimType;
      if (claims) {
        for (let index = 0; index < claims.length; index++) {
          ret = this.isClaimValid(claims[index]);
          // If one is successful, then let them in
          if (ret) {
            break;
          }
        }
      }
    }
    return ret;
  }

  private isClaimValid(claimType: string): boolean {
    let ret: boolean = false;
    let auth: SecurityUser = null;
    let claimValue: boolean = false

    // Retrieve security object
    auth = this.currentUser;
    if (auth) {
      // See if the claim type has a value
      // *hasClaim="'claimType:value'"
      if (claimType.indexOf(":") >= 0) {
        let words: string[] = claimType.split(":");
        claimType = words[0].toLowerCase();
        claimValue = words[1] == "true";
      }
      else {
        claimType = claimType.toLowerCase();
        // Either get the claim value, or assume 'true'
        claimValue = claimValue ? claimValue : true;
      }
      // Attempt to find the claim
      ret = auth.Claims.find(
        c => c.Claim.toLowerCase() == claimType
          && c.HasAccess == claimValue) != null;
    }

    return ret;
  }


}

